"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextScript = exports.Main = exports.Head = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _getPrototypeOf = _interopRequireDefault(require("@babel/runtime/core-js/object/get-prototype-of"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _htmlescape = _interopRequireDefault(require("htmlescape"));

var _server = _interopRequireDefault(require("styled-jsx/server"));

/* eslint-disable */
var Fragment = _react.default.Fragment || function Fragment(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", null, children);
};

var Document =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Document, _Component);

  function Document() {
    (0, _classCallCheck2.default)(this, Document);
    return (0, _possibleConstructorReturn2.default)(this, (Document.__proto__ || (0, _getPrototypeOf.default)(Document)).apply(this, arguments));
  }

  (0, _createClass2.default)(Document, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        _documentProps: this.props
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("html", null, _react.default.createElement(Head, null), _react.default.createElement("body", null, _react.default.createElement(Main, null), _react.default.createElement(NextScript, null)));
    }
  }], [{
    key: "getInitialProps",
    value: function getInitialProps(_ref2) {
      var renderPage = _ref2.renderPage;

      var _renderPage = renderPage(),
          html = _renderPage.html,
          head = _renderPage.head,
          errorHtml = _renderPage.errorHtml,
          chunks = _renderPage.chunks,
          buildManifest = _renderPage.buildManifest;

      var styles = (0, _server.default)();
      return {
        html: html,
        head: head,
        errorHtml: errorHtml,
        chunks: chunks,
        styles: styles,
        buildManifest: buildManifest
      };
    }
  }]);
  return Document;
}(_react.Component);

exports.default = Document;
Object.defineProperty(Document, "childContextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    _documentProps: _propTypes.default.any
  }
});

var Head =
/*#__PURE__*/
function (_Component2) {
  (0, _inherits2.default)(Head, _Component2);

  function Head() {
    (0, _classCallCheck2.default)(this, Head);
    return (0, _possibleConstructorReturn2.default)(this, (Head.__proto__ || (0, _getPrototypeOf.default)(Head)).apply(this, arguments));
  }

  (0, _createClass2.default)(Head, [{
    key: "getChunkPreloadLink",
    value: function getChunkPreloadLink(filename) {
      var _this = this;

      var _context$_documentPro = this.context._documentProps,
          __NEXT_DATA__ = _context$_documentPro.__NEXT_DATA__,
          buildManifest = _context$_documentPro.buildManifest;
      var assetPrefix = __NEXT_DATA__.assetPrefix,
          buildId = __NEXT_DATA__.buildId;
      var files = buildManifest[filename];
      return files.map(function (file) {
        return _react.default.createElement("link", {
          key: filename,
          nonce: _this.props.nonce,
          rel: "preload",
          href: "".concat(assetPrefix, "/_next/").concat(file),
          as: "script"
        });
      });
    }
  }, {
    key: "getPreloadMainLinks",
    value: function getPreloadMainLinks() {
      var dev = this.context._documentProps.dev;

      if (dev) {
        return (0, _toConsumableArray2.default)(this.getChunkPreloadLink('manifest.js')).concat((0, _toConsumableArray2.default)(this.getChunkPreloadLink('main.js')));
      } // In the production mode, we have a single asset with all the JS content.


      return (0, _toConsumableArray2.default)(this.getChunkPreloadLink('main.js'));
    }
  }, {
    key: "getPreloadDynamicChunks",
    value: function getPreloadDynamicChunks() {
      var _this2 = this;

      var _context$_documentPro2 = this.context._documentProps,
          chunks = _context$_documentPro2.chunks,
          __NEXT_DATA__ = _context$_documentPro2.__NEXT_DATA__;
      var assetPrefix = __NEXT_DATA__.assetPrefix;
      return chunks.filenames.map(function (chunk) {
        return _react.default.createElement("link", {
          key: chunk,
          rel: "preload",
          href: "".concat(assetPrefix, "/_next/webpack/chunks/").concat(chunk),
          as: "script",
          nonce: _this2.props.nonce
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _context$_documentPro3 = this.context._documentProps,
          head = _context$_documentPro3.head,
          styles = _context$_documentPro3.styles,
          __NEXT_DATA__ = _context$_documentPro3.__NEXT_DATA__;
      var page = __NEXT_DATA__.page,
          pathname = __NEXT_DATA__.pathname,
          buildId = __NEXT_DATA__.buildId,
          assetPrefix = __NEXT_DATA__.assetPrefix;
      var pagePathname = getPagePathname(pathname);
      return _react.default.createElement("head", this.props, (head || []).map(function (h, i) {
        return _react.default.cloneElement(h, {
          key: h.key || i
        });
      }), page !== '/_error' && _react.default.createElement("link", {
        rel: "preload",
        href: "".concat(assetPrefix, "/_next/").concat(buildId, "/page").concat(pagePathname),
        as: "script",
        nonce: this.props.nonce
      }), _react.default.createElement("link", {
        rel: "preload",
        href: "".concat(assetPrefix, "/_next/").concat(buildId, "/page/_app.js"),
        as: "script",
        nonce: this.props.nonce
      }), _react.default.createElement("link", {
        rel: "preload",
        href: "".concat(assetPrefix, "/_next/").concat(buildId, "/page/_error.js"),
        as: "script",
        nonce: this.props.nonce
      }), this.getPreloadDynamicChunks(), this.getPreloadMainLinks(), styles || null, this.props.children);
    }
  }]);
  return Head;
}(_react.Component);

exports.Head = Head;
Object.defineProperty(Head, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    _documentProps: _propTypes.default.any
  }
});
Object.defineProperty(Head, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    nonce: _propTypes.default.string
  }
});

var Main =
/*#__PURE__*/
function (_Component3) {
  (0, _inherits2.default)(Main, _Component3);

  function Main() {
    (0, _classCallCheck2.default)(this, Main);
    return (0, _possibleConstructorReturn2.default)(this, (Main.__proto__ || (0, _getPrototypeOf.default)(Main)).apply(this, arguments));
  }

  (0, _createClass2.default)(Main, [{
    key: "render",
    value: function render() {
      var _context$_documentPro4 = this.context._documentProps,
          html = _context$_documentPro4.html,
          errorHtml = _context$_documentPro4.errorHtml;
      return _react.default.createElement(Fragment, null, _react.default.createElement("div", {
        id: "__next",
        dangerouslySetInnerHTML: {
          __html: html
        }
      }), _react.default.createElement("div", {
        id: "__next-error",
        dangerouslySetInnerHTML: {
          __html: errorHtml
        }
      }));
    }
  }]);
  return Main;
}(_react.Component);

exports.Main = Main;
Object.defineProperty(Main, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    _documentProps: _propTypes.default.any
  }
});

var NextScript =
/*#__PURE__*/
function (_Component4) {
  (0, _inherits2.default)(NextScript, _Component4);

  function NextScript() {
    (0, _classCallCheck2.default)(this, NextScript);
    return (0, _possibleConstructorReturn2.default)(this, (NextScript.__proto__ || (0, _getPrototypeOf.default)(NextScript)).apply(this, arguments));
  }

  (0, _createClass2.default)(NextScript, [{
    key: "getChunkScript",
    value: function getChunkScript(filename) {
      var _this3 = this;

      var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _context$_documentPro5 = this.context._documentProps,
          __NEXT_DATA__ = _context$_documentPro5.__NEXT_DATA__,
          buildManifest = _context$_documentPro5.buildManifest;
      var assetPrefix = __NEXT_DATA__.assetPrefix,
          buildId = __NEXT_DATA__.buildId;
      var files = buildManifest[filename];
      return files.map(function (file) {
        return _react.default.createElement("script", (0, _extends2.default)({
          key: filename,
          src: "".concat(assetPrefix, "/_next/").concat(file),
          nonce: _this3.props.nonce
        }, additionalProps));
      });
    }
  }, {
    key: "getScripts",
    value: function getScripts() {
      var dev = this.context._documentProps.dev;

      if (dev) {
        return (0, _toConsumableArray2.default)(this.getChunkScript('manifest.js')).concat((0, _toConsumableArray2.default)(this.getChunkScript('main.js')));
      } // In the production mode, we have a single asset with all the JS content.
      // So, we can load the script with async


      return (0, _toConsumableArray2.default)(this.getChunkScript('main.js', {
        async: true
      }));
    }
  }, {
    key: "getDynamicChunks",
    value: function getDynamicChunks() {
      var _this4 = this;

      var _context$_documentPro6 = this.context._documentProps,
          chunks = _context$_documentPro6.chunks,
          __NEXT_DATA__ = _context$_documentPro6.__NEXT_DATA__;
      var assetPrefix = __NEXT_DATA__.assetPrefix;
      return _react.default.createElement(Fragment, null, chunks.filenames.map(function (chunk) {
        return _react.default.createElement("script", {
          async: true,
          key: chunk,
          src: "".concat(assetPrefix, "/_next/webpack/chunks/").concat(chunk),
          nonce: _this4.props.nonce
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _context$_documentPro7 = this.context._documentProps,
          staticMarkup = _context$_documentPro7.staticMarkup,
          __NEXT_DATA__ = _context$_documentPro7.__NEXT_DATA__,
          chunks = _context$_documentPro7.chunks;
      var page = __NEXT_DATA__.page,
          pathname = __NEXT_DATA__.pathname,
          buildId = __NEXT_DATA__.buildId,
          assetPrefix = __NEXT_DATA__.assetPrefix;
      var pagePathname = getPagePathname(pathname);
      __NEXT_DATA__.chunks = chunks.names;
      return _react.default.createElement(Fragment, null, staticMarkup ? null : _react.default.createElement("script", {
        nonce: this.props.nonce,
        dangerouslySetInnerHTML: {
          __html: "\n          __NEXT_DATA__ = ".concat((0, _htmlescape.default)(__NEXT_DATA__), "\n          module={}\n          __NEXT_LOADED_PAGES__ = []\n          __NEXT_LOADED_CHUNKS__ = []\n\n          __NEXT_REGISTER_PAGE = function (route, fn) {\n            __NEXT_LOADED_PAGES__.push({ route: route, fn: fn })\n          }\n\n          __NEXT_REGISTER_CHUNK = function (chunkName, fn) {\n            __NEXT_LOADED_CHUNKS__.push({ chunkName: chunkName, fn: fn })\n          }\n\n          ").concat(page === '_error' && "\n          __NEXT_REGISTER_PAGE(".concat((0, _htmlescape.default)(pathname), ", function() {\n            var error = new Error('Page does not exist: ").concat((0, _htmlescape.default)(pathname), "')\n            error.statusCode = 404\n\n            return { error: error }\n          })\n          "), "\n        ")
        }
      }), page !== '/_error' && _react.default.createElement("script", {
        async: true,
        id: "__NEXT_PAGE__".concat(pathname),
        src: "".concat(assetPrefix, "/_next/").concat(buildId, "/page").concat(pagePathname),
        nonce: this.props.nonce
      }), _react.default.createElement("script", {
        async: true,
        id: "__NEXT_PAGE__/_app",
        src: "".concat(assetPrefix, "/_next/").concat(buildId, "/page/_app.js"),
        nonce: this.props.nonce
      }), _react.default.createElement("script", {
        async: true,
        id: "__NEXT_PAGE__/_error",
        src: "".concat(assetPrefix, "/_next/").concat(buildId, "/page/_error.js"),
        nonce: this.props.nonce
      }), staticMarkup ? null : this.getDynamicChunks(), staticMarkup ? null : this.getScripts());
    }
  }]);
  return NextScript;
}(_react.Component);

exports.NextScript = NextScript;
Object.defineProperty(NextScript, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    nonce: _propTypes.default.string
  }
});
Object.defineProperty(NextScript, "contextTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    _documentProps: _propTypes.default.any
  }
});

function getPagePathname(pathname) {
  if (pathname === '/') {
    return '/index.js';
  }

  return "".concat(pathname, ".js");
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/next/dist/server/document.js
// module id = ../node_modules/next/dist/server/document.js
// module chunks = 1